import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { Button } from "@faire/web--source/slate/Button";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
var getBackgroundPosition = function(image) {
    if (image === null || image === void 0 ? void 0 : image.tags.some(function(i) {
        return i === "low_crop";
    })) {
        return "center 70%";
    } else if (image === null || image === void 0 ? void 0 : image.tags.some(function(i) {
        return i === "high_crop";
    })) {
        return "center 30%";
    } else {
        return "center 50%";
    }
};
var ImageWrapper = function(param) {
    var tile = param.tile, isSSR = param.isSSR;
    var _tile_image;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsx(BannerImage, {
                $image: optimizeImageUrl({
                    url: (_tile_image = tile.image) === null || _tile_image === void 0 ? void 0 : _tile_image.url
                }, isSSR, {
                    width: 497
                }),
                $backgroundPosition: getBackgroundPosition(tile.image)
            }),
            /*#__PURE__*/ _jsx(ImageCaption, {
                tile: tile
            })
        ]
    });
};
var ImageCaption = function(param) {
    var tile = param.tile;
    if (!tile.cta_text) {
        return null;
    }
    return /*#__PURE__*/ _jsx(BrandName, {
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "labelSansRegular",
            color: Core.text.subdued,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "9x1Apf",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Featured brand: "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 1,
                                value: "brandCompanyName"
                            }
                        ]
                    }
                ],
                values: {
                    brandCompanyName: tile.cta_text,
                    LinkFormatting: LinkFormatting(tile.cta_link)
                }
            })
        })
    });
};
function LinkFormatting(linkTo) {
    return function(chunks) {
        if (linkTo) {
            return /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                linkTo: linkTo,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "labelSansRegular",
                    color: Core.text.subdued,
                    children: chunks
                })
            });
        } else {
            return chunks;
        }
    };
}
export var EcoFriendlyC2PageImageSlider = function(param) {
    var tiles = param.tiles, sliderRef = param.sliderRef, isSSR = param.isSSR;
    return /*#__PURE__*/ _jsx(StyledSlider, {
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        pauseOnHover: true,
        ref: sliderRef,
        draggable: false,
        children: tiles.map(function(tile, index) {
            var _tile_image;
            var _tile_image_url;
            return /*#__PURE__*/ _jsx(ImageWrapper, {
                tile: tile,
                isSSR: isSSR
            }, (_tile_image_url = (_tile_image = tile.image) === null || _tile_image === void 0 ? void 0 : _tile_image.url) !== null && _tile_image_url !== void 0 ? _tile_image_url : index);
        })
    });
};
var StyledSlider = styled(Slider).withConfig({
    componentId: "sc-2c5bd1de-0"
})([
    "width:50%;> div{height:100% !important;}",
    "{width:100%;height:272px;> div{height:272px !important;}}",
    "{overflow:hidden;height:120px;> div{height:120px !important;}}.slick-track{height:100%;}.slick-track div{height:100%;}"
], responsiveMediaQueries.tabletAndBelow, responsiveMediaQueries.mobile);
var Wrapper = styled.div.withConfig({
    componentId: "sc-2c5bd1de-1"
})([
    "width:100%;height:100%;position:relative;overflow-y:visible;"
]);
var BrandName = styled.div.withConfig({
    componentId: "sc-2c5bd1de-2"
})([
    "width:100%;height:20px !important;text-align:right;margin-top:4px;position:absolute;left:0;user-select:text;-moz-user-select:text;-webkit-user-select:text;",
    "{height:0px !important;display:none;}"
], responsiveMediaQueries.tabletAndBelow);
var BannerImage = styled.div.withConfig({
    componentId: "sc-2c5bd1de-3"
})([
    "flex-shrink:0;width:100%;height:calc(100% - ",
    ") !important;background-image:url(",
    ");background-size:cover;background-position:",
    ";",
    "{height:100% !important;}"
], getSpacing("3x"), function(props) {
    return props.$image;
}, function(props) {
    return props.$backgroundPosition;
}, responsiveMediaQueries.tabletAndBelow);
